<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <!--
        <vs-button :to="`/conferences/booths/add`" color="primary" type="filled"
          >Add New</vs-button
        >
        -->
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <!--
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
        -->
      </vs-col>
    </vs-row>

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(onboarding_status)="data">
          <div style="width: 120px">
            <vs-chip v-if="data.item.onboarding_status" color="success"
              >Completed</vs-chip
            >
            <vs-chip v-else color="warning">In Progress</vs-chip>
          </div>
        </template>

        <template v-slot:cell(publish_status)="data">
          <vs-switch
            v-model="data.item.publish_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(featured_status)="data">
          <vs-switch
            v-model="data.item.featured_status"
            icon-pack="feather"
            vs-icon="icon-star"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
      </b-table>
    </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  data: () => ({
    urlSuffix: "",
    columns: [
      { label: "ID", key: "booth_id", sortable: false },
      {
        label: "Onboarding Status",
        key: "onboarding_status",
        sortable: false,
        tdClass: "width-450",
      },
      { label: "Publish Status", key: "publish_status", sortable: false },
      { label: "Featured Status", key: "featured_status", sortable: false },
      {
        label: "Company Name",
        key: "company_name",
        sortable: false,
        tdClass: "width-300",
      },
      {
        label: "Slug",
        key: "slug",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Weight",
        key: "weight",
        sortable: false,
        tdClass: "width-300",
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false },
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 100,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50, 100],
  }),
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
  created() {
    this.urlSuffix = "?s=" + this.s + "&e=" + this.e;
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        Service.Booth.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows.map((item) => {
              let company_name = null;
              let onboarding_status = false;
              if (item.company != null) {
                company_name = item.company.company_name;
                if (item.company.onboarding_step == 4) {
                  onboarding_status = true;
                }
              }
              return {
                ...item,
                company_name: company_name,
                onboarding_status: onboarding_status,
              };
            });

            console.log(this.data);
            this.log = res.log;

            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 800);
    },
    open(item) {
      this.$router.push(
        "/conferences/booths/" + item.booth_id + "/view" + this.urlSuffix
      );
    },
    onStatusChanged: _.debounce(function (e) {
      let data = {
        e: this.e,
        booth_id: e.booth_id,
        publish_status: e.publish_status,
        featured_status: e.featured_status,
      };

      this.$vs.loading();
      Service.Booth.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
    /*
    list(item) {
      console.log(item);
      if(item.filter_tbl=='sponsor'){
          console.log()
      }
    },
    */
    /*
    duplicate(item) {
      this.$router.push("/conferences/speakers/add?clone=" + item.e);
    },
    */
  },
};
</script>